import type { ComponentProps } from "react";
import { DayPicker } from "@daypicker/react";

import { cn } from "@/lib/utils";

import "@daypicker/react/style.css";
import "./calendar.css";

type CalendarProps = ComponentProps<typeof DayPicker>;

export const Calendar = ({
  className,
  captionLayout = "dropdown",
  startMonth = new Date(2010, 0),
  ...props
}: CalendarProps) => (
  <DayPicker
    {...props}
    captionLayout={captionLayout}
    startMonth={startMonth}
    className={cn("report-calendar", className)}
  />
);
